import OrderApi from "@/services/api/orderApi";
import { mapGetters } from "vuex";
import paymentTerms from "../../paymentTerms/paymentTerms.vue";

const OrderApiService = new OrderApi();

export default {
  props: ["hasChosenNet0"],
  components: { paymentTerms },
  data() {
    return {
      shippingState: null,
      isExpanded: true,
      promo_code_invalid: false,
      promo_code_error_message: "",
      promo_code: "",
    };
  },

  methods: {
    getCart,
    shippingUpdatedCallback,
    sendError,
    applyPromoCode,
    removePromoCode,
  },

  beforeMount() {
    this.shippingUpdatedCallback();
    this.getCart();
  },

  mounted() {
    window.addEventListener("focus", this.getCart);
    this.$eventBus.$on("promo-code-added", this.applyPromoCode);
    this.$eventBus.$on("promo-code-removed", this.removePromoCode);
    this.$eventBus.$on("shipping-updated", this.shippingUpdatedCallback);
  },

  beforeDestroy() {
    window.removeEventListener("focus", this.getCart);
    this.$eventBus.$off("promo-code-removed", this.removePromoCode);
    this.$eventBus.$off("promo-code-added", this.applyPromoCode);
    this.$eventBus.$off("shipping-updated", this.shippingUpdatedCallback);
  },

  watch: {
    $route: function () {
      this.getCart();
    },
  },

  computed: {
    cart() {
      return this.$store.getters.checkoutState.cart;
    },

    isPromoCodeLoading() {
      return this.$store.getters.checkoutState.isPromoCodeLoading;
    },

    orderHasAdminPromoCode() {
      return this.cart.sub_carts.filter((sub_cart) => {
        return sub_cart.admin_promo_code;
      });
    },

    ...mapGetters({
      user: "userState",
      promoCodeState: "promoCodeState",
    }),
  },

  watch: {
    cartPromoCode(val) {
      this.promo_code = val || "";
    },
  },
};

async function getCart() {
  let cart = null;

  try {
    cart = (await this.$utils.getCart(true)).data;
    this.$utils.checkCartChanges(this, cart);

    if (!cart.valid_mov || cart.has_deleted_items) {
      this.$router.push("/checkout");
    }
  } catch (error) {
    this.$swal("Attention", error.response.data.error_message);
    this.$router.push("/checkout");

    return;
  }

  if (!cart.sub_carts.length) {
    this.$router.push("/checkout");
  } else {
    this.$store.commit("setCart", cart);
  }

  if (cart.promo_code) {
    this.promo_code = cart.promo_code;
  }
}

function shippingUpdatedCallback() {
  // used to avoid having live updates while filling out new addresses
  this.shippingState = JSON.parse(JSON.stringify(this.$store.getters.checkoutState.shipping));
}

async function applyPromoCode(code) {
  const _self = this;

  if (code) {
    _self.promo_code = code;
  }

  _self.$store.commit("setPromoCodeInvalid", false);
  _self.$store.commit("setPromoCodeErrorMessage", null);
  let promo_code = _self.promo_code.trim();

  if (promo_code.length && _self.$root.alphaNumericPattern.test(promo_code.toLowerCase())) {
    _self.$store.commit("setPromoCodeLoadingState", true);
    await _self.$utils
      .applyPromoCode({ promo_code: promo_code })
      .then((response) => {
        _self.$ma.trackEvent({ action: "Promo Code", properties: { Success: true, "Promo code": promo_code } });
        _self.$swal("Success", "You have successfully applied promo code! " + response.data.message);
        _self.getCart();
      })
      .catch((error) => {
        if (error.response.data.status === 409) {
          _self.$ma.trackEvent({
            action: "Promo Code",
            properties: { Success: false, Error: "Promo code already used", "Promo code": promo_code },
          });
          _self.sendError("Promo code already used (via API)", _self.promo_code);
        } else {
          _self.$ma.trackEvent({
            action: "Promo Code",
            properties: { Success: false, Error: "Promo Code not found", "Promo code": promo_code },
          });
          _self.sendError("Promo code not found (via API)", _self.promo_code);
        }

        if (error.response.data.error_message) {
          _self.promo_code_error_message = error.response.data.error_message;
        }

        _self.$store.commit("setPromoCodeInvalid", true);
        _self.$store.commit("setPromoCodeErrorMessage", _self.promo_code_error_message);
      })
      .finally(() => {
        _self.promo_code = "";
        _self.$store.commit("setPromoCodeLoadingState", false);
      });
  } else {
    // send report to bugsnag
    _self.$ma.trackEvent({
      action: "Promo Code",
      properties: { Success: false, Error: "Promo Code not valid", "Promo code": promo_code },
    });
    _self.sendError("Promo code not valid (via Frontend)", _self.promo_code);
    _self.$swal("Attention", "Promo code not valid.");
  }
}

function removePromoCode(code) {
  this.$store.commit("setPromoCodeLoadingState", true);
  OrderApiService.removePromoCode(code)
    .then(() => {
      this.getCart();
      this.$swal("Success", "The promo code for your order has been successfully removed.");
    })
    .catch((error) => {
      if (error.response) {
        this.$swal("Attention", error.response.data.error_message);
      } else {
        this.$logger.notify(new Error(error));
      }
    })
    .finally(() => {
      this.$store.commit("setPromoCodeLoadingState", false);
    });
}

function sendError(text, code) {
  let user = this.$session.getUserInfo();

  this.$logger.notify(new Error(text + ". Promo code: [" + code + "] User: " + user.email));
}
